import { ValidationFunction } from './Validator.interface'

const MIN_LENGTH_ERROR_TEMPLATE = (minLength: number) =>
  `Minimum length must be at least ${minLength}`
export const IsMinLengthValidator =
  (minLength: number, errorTemplate = MIN_LENGTH_ERROR_TEMPLATE): ValidationFunction =>
  (inputValue) => {
    const value = inputValue ? inputValue.toString() : ''
    if (!value) {
      return ''
    }

    if (value.length < minLength) {
      return errorTemplate(minLength)
    }
    return ''
  }
